<template>
  <div class="insurance-offers">
    <div class="insurance-offers__results">
      <PropositionsListHeader
        :is-loading="isLoadingOffers"
        :found="getOffersCount"
        :show-earnings="getShowEarnings"
        @changeShowEarnings="onChangeShowEarnings"
      />
      <CompaniesFilter
        :disable="isLoadingOffers"
        :companies="getCompaniesNamesList"
        :selected-company="getSelectedCompanies"
        checkbox-style="styled"
      />

      <OffersListSkeleton :is-loading="isLoadingOffers">
        <OffersList
          :show-earnings="getShowEarnings"
          :offers="getFilteredOffersList"
          :is-loading="isLoading"
          @select-offer="onSelectOffer"
        />
      </OffersListSkeleton>

      <div
        v-if="isDisplayScrollToTop && windowWidth > 1200"
        class="insurance-offers__to-top"
      >
        <WhiteButton
          class="insurance-offers__to-top__btn"
          size="large"
          @click="scrollToTop"
        >
          Вгору
          <OpenDownIcon
            class="insurance-offers__to-top__icon"
            color="#717680"
          />
        </WhiteButton>
      </div>
    </div>

    <div
      v-if="isDisplayScrollToTop && windowWidth <= 1200"
      class="insurance-offers__to-top"
    >
      <WhiteButton
        class="insurance-offers__to-top__btn"
        size="large"
        @click="scrollToTop"
      >
        Вгору
        <OpenDownIcon
          class="insurance-offers__to-top__icon"
          color="#717680"
        />
      </WhiteButton>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { default as OffersList } from './offers-list/index.vue';
import { default as OffersListSkeleton } from './offers-list-skeleton/index.vue';
import { PETS_OFFERS_FILTER_EVENTS } from '@/features/pets-offers';
import { FilterCalculator } from '@/shared/lib/filter';
import { scrollToTop } from '@/shared/lib/scroll';
import { WhiteButton } from '@/shared/ui/form';
import { OpenDownIcon } from '@/shared/ui/icons';
import {
  CompaniesFilter,
  PropositionsListHeader
} from '@/shared/ui/insurance';

const { calculateFilterValues } = FilterCalculator();

export default {
  props: {
    calculationParams: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  created() {
    this.$eventBus.$on(PETS_OFFERS_FILTER_EVENTS.PETS_OFFERS_FILTER_BY_COMPANY, this.setCompanyFilter);
  },
  beforeDestroy() {
    this.$eventBus.$off(PETS_OFFERS_FILTER_EVENTS.PETS_OFFERS_FILTER_BY_COMPANY, this.setCompanyFilter);
  },
  mounted() {
    this.calculateOffers({ ...this.calculationParams });
  },
  mixins: [scrollToTop],
  components: {
    PropositionsListHeader, CompaniesFilter, OffersList, OffersListSkeleton,
    WhiteButton, OpenDownIcon,
  },
  computed: {
    ...mapGetters('layoutModule', ['isMobile', 'windowWidth']),
    ...mapGetters('petsOffersModule', [
      'isLoadingOffers', 'getFilteredOffersList', 'getOffersCount', 'getShowEarnings', 'getCompaniesList',
      'getActiveFilters',
    ]),
    getCompaniesNamesList() {
      const companies = this.getCompaniesList || [];
      return companies.map(company => ({
        id: company.id,
        name: company.name,
        event: PETS_OFFERS_FILTER_EVENTS.PETS_OFFERS_FILTER_BY_COMPANY,
        options: {
          type: 'checkbox',
          multiselect: true,
        },
      }));
    },
    getSelectedCompanies() {
      const companiesList = this.getCompaniesNamesList || [];
      const selectedCompanies = this.getActiveFilters?.companies || [];

      const companyIds = companiesList
        .filter(company => selectedCompanies.includes(company?.name))
        .map(company => company?.id);

      return { id: companyIds };
    },
    isDisplayScrollToTop() {
      return this.getFilteredOffersList?.length >= 4;
    },
  },
  methods: {
    ...mapActions('petsModule', ['setOffer']),
    ...mapActions('petsOffersModule', [
      'calculateOffers', 'setShowEarnings', 'setupFilter',
    ]),
    onChangeShowEarnings(showEarnings) {
      this.setShowEarnings(showEarnings);
    },
    onSelectOffer(offer) {
      this.isLoading = true;
      this.setOffer(offer);
      this.$router.push({ name: 'petsPolicyDetails' });
    },
    setCompanyFilter(company) {
      const selectedCompanies = calculateFilterValues(this.getActiveFilters, 'companies', company?.name, true);
      this.setupFilter({ filters: selectedCompanies, mode: 'update' });
    },
  },
};
</script>

<style lang="scss" scoped>
.insurance-offers {
  display: flex;

  @media (max-width: 1200px) {
    flex-direction: column;
  }

  &__results {
    width: 100%;
    margin-right: 16px;
    order: 1;

    @media (max-width: 1200px) {
      margin-right: 0;
    }
  }

  &__to-top {
    display: flex;
    justify-content: center;
    margin-top: 32px;

    &__btn {
      font-weight: 400;
      color: #717680;
      padding: 12px 32px;
    }

    &__icon {
      margin-left: 8px;
      transform: rotate(180deg);
    }
  }
}
</style>
